// extracted by mini-css-extract-plugin
export var infoItem = "_ra-2";
export var title = "_ra-0";
export var value = "_ra-1";